import api from "../axios";

export const vendorProfileApi = (data) => api.get("vendor/profile", data);
export const VendorUpdateProfileApi = (data) =>
  api.patch("vendor/update-profile", data);
export const VedorDetails = (data) => api.get(`vendor/details/${data}`, data);
export const VendorHomeApi = (data) => api.get("vendor/home", data);
export const VendorHostedEventsApi = (data) => api.get("vendor/events", data);
export const VendorBookedTicketApi = (data) =>
  api.get(`vendor/${data}/tickets`, data);
export const VendorCreateOffer = (data) =>
  api.post("vendor/create-offer", data);
export const VendorCreateEvent = (data) =>
  api.post("/vendor/create-event", data);
export const VendorUpdateEvent = (data) =>
  api.patch(`vendor/event/update-event`, data);
export const VendorUpdateTicketStatus = (data) =>
  api.patch(`ticket/update-payment-status`, data); // Note: URL is ticket/ but wrapper name is Vendor...
export const VendorCreateVenue = (data) => api.post("venue/create-venue", data); // Note: URL is venue/ but wrapper name is Vendor...
export const VendorUnverifiedEvents = (data) =>
  api.get("/vendor/listing/unverified", data);
